import { TypedValue } from "src/types/typedValue";

export const areTypedValuesEqual = (value1: TypedValue, value2: TypedValue) => {
  if (
    (value1.type === "date" || value1.type === "dateTime") &&
    (value2.type === "date" || value2.type === "dateTime")
  ) {
    return value1.value.getTime() === value2.value.getTime();
  }

  return value1.value === value2.value;
};
